import { ChangeEvent } from 'react';
import { FiltersKeys } from '../types';
import { IProductDataTransformed } from '@queries/products/useProductsList/types';
import { PermissionType } from '@enums/permissionType.enum';

export interface IProductsToolbarProps {
  productList: IProductDataTransformed[];
  searchValue: string;
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void;
  onFiltersChange: (key: FiltersKeys, value: string | number | boolean) => void;
}

export const createNewProductAccessUsers = [
  PermissionType.ADMIN,
  PermissionType.BROKER,
  PermissionType.UNDERWRITER,
  PermissionType.FINANCE,
];
